'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var SUPPORT_EMAIL = _constants.AppConstants.SUPPORT_EMAIL;

var EmailConfirmation = function (_Component) {
  _inherits(EmailConfirmation, _Component);

  function EmailConfirmation() {
    _classCallCheck(this, EmailConfirmation);

    return _possibleConstructorReturn(this, (EmailConfirmation.__proto__ || Object.getPrototypeOf(EmailConfirmation)).apply(this, arguments));
  }

  _createClass(EmailConfirmation, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Email sent!'
        ),
        _react2.default.createElement(
          'div',
          null,
          'Check your inbox for instructions from us on how to reset your password.'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          null,
          'Unsure if that email address was correct? Please contact us at ',
          _react2.default.createElement(
            'a',
            { href: 'mailto:' + SUPPORT_EMAIL + '?Subject=Password%20Reset' },
            SUPPORT_EMAIL
          ),
          ' or message us on chat.'
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return EmailConfirmation;
}(_react.Component);

var _default = EmailConfirmation;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SUPPORT_EMAIL, 'SUPPORT_EMAIL', '/app/src/components/page-password-reset/EmailConfirmation.js');
  reactHotLoader.register(EmailConfirmation, 'EmailConfirmation', '/app/src/components/page-password-reset/EmailConfirmation.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-password-reset/EmailConfirmation.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtcGFzc3dvcmQtcmVzZXQvRW1haWxDb25maXJtYXRpb24uanMiXSwibmFtZXMiOlsiU1VQUE9SVF9FTUFJTCIsIkFwcENvbnN0YW50cyIsIkVtYWlsQ29uZmlybWF0aW9uIiwiQ29tcG9uZW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBOzs7O0FBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFHRUEsYSxHQUNFQyx1QixDQURGRCxhOztJQUdJRSxpQjs7Ozs7Ozs7Ozs7NkJBQ007QUFDUixhQUNFO0FBQUE7QUFBQTtBQUNFO0FBQUE7QUFBQTtBQUFBO0FBQUEsU0FERjtBQUVFO0FBQUE7QUFBQTtBQUFBO0FBQUEsU0FGRjtBQUlRLGlEQUpSO0FBS0U7QUFBQTtBQUFBO0FBQUE7QUFDaUU7QUFBQTtBQUFBLGNBQUcsa0JBQWdCRixhQUFoQiw4QkFBSDtBQUE4REE7QUFBOUQsV0FEakU7QUFBQTtBQUFBO0FBTEYsT0FERjtBQVdEOzs7Ozs7Ozs7OztFQWI2QkcsZ0I7O2VBZ0JqQkQsaUI7Ozs7Ozs7Ozs7OzBCQW5CYkYsYTswQkFHSUUsaUIiLCJmaWxlIjoiRW1haWxDb25maXJtYXRpb24uanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IEFwcENvbnN0YW50cyB9IGZyb20gJy4uLy4uL2NvbnN0YW50cyc7XG5cbmNvbnN0IHtcbiAgU1VQUE9SVF9FTUFJTCxcbn0gPSBBcHBDb25zdGFudHM7XG5cbmNsYXNzIEVtYWlsQ29uZmlybWF0aW9uIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgcmVuZGVyICgpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPGRpdj5cbiAgICAgICAgPGgxPkVtYWlsIHNlbnQhPC9oMT5cbiAgICAgICAgPGRpdj5cbiAgICAgICAgICBDaGVjayB5b3VyIGluYm94IGZvciBpbnN0cnVjdGlvbnMgZnJvbSB1cyBvbiBob3cgdG8gcmVzZXQgeW91ciBwYXNzd29yZC5cbiAgICAgICAgPC9kaXY+PGJyIC8+XG4gICAgICAgIDxkaXY+XG4gICAgICAgICAgVW5zdXJlIGlmIHRoYXQgZW1haWwgYWRkcmVzcyB3YXMgY29ycmVjdD8gUGxlYXNlIGNvbnRhY3QgdXMgYXQgPGEgaHJlZj17YG1haWx0bzoke1NVUFBPUlRfRU1BSUx9P1N1YmplY3Q9UGFzc3dvcmQlMjBSZXNldGB9PntTVVBQT1JUX0VNQUlMfTwvYT4gb3IgbWVzc2FnZSB1cyBvbiBjaGF0LlxuICAgICAgICA8L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgICk7XG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgRW1haWxDb25maXJtYXRpb247XG4iXX0=